import moment from 'moment'
import GenericService from '@/services/GenericService'
import CreditsManagerService from '@/services/CreditsManagerService'
import CreditStatus from '@/common/CreditsStatus'
import Utils from '@/common/Utils.js'
import Vue from 'vue'

export default {
    data () {
        return {
            GenericService,
            CreditStatus,
            Utils,
            Vue,
            moment,
            failed: false
        }
    },

    methods: {
        async loadRecords (page, apiEndpoint, recordsName, countName, searchRecord = {}, callback = this.onRecordLoad) {
            let loader = this.$loading.show()
            this[recordsName || 'records'] = []
            if (!apiEndpoint && !Object.keys(searchRecord).length) {
                searchRecord = Object.assign({}, this.searchRecord)
            }
            if (page && typeof (page) !== 'object') {
                searchRecord.page = page
            }
            try {
                const service = this.recordService || GenericService
                let data = await service.getAll(apiEndpoint || this.apiEndpoint, searchRecord)
                this[recordsName || 'records'] = data.items
                this[countName || 'total'] = data.count ? data.count : data.items.length

                await callback(this[recordsName || 'records'])

                loader.hide()
            } catch (error) {
                loader.hide()
                console.error(error)
                this.$swal({
                    title: 'Error',
                    text: 'No se pudieron cargar los registros, contacta al administrador',
                    icon: 'error'
                })
            }
        },

        async restoreRecords (apiEndpoint, recordsName, countName, searchRecord) {
            this[searchRecord || 'searchRecord'] = {
                page: 1,
                pageSize: 35,
                order: 'ASC'
            }
            this.loadRecords(1, apiEndpoint || this.apiEndpoint, recordsName || this.recordsName, countName || this.countName, this.searchRecord)
        },

        addRecord () {
            if (!Utils.userHasPerm('can_add_' + this.recordName)) {
                this.$swal({
                    title: 'No tienes permiso para realizar la acción',
                    html: 'Debes solicitar permiso al administrador',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Cerrar',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: true
                })
                return
            }
            this.$router.push({ name: this.recordName + 'Detail' })
        },

        canAddRecod () {
            if (!this.$route.params.id && !Utils.userHasPerm('can_add_' + this.recordName)) {
                this.$swal({
                    title: 'No tienes permiso para realizar la acción',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Volver al listado',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: false
                }).then((result) => {
                    let routeData = this.$router.resolve({ name: this.recordName + 'List' })
                    window.open(routeData.href, '_self')
                })
            }
        },

        async loadRecordsCM2 (page, apiEndpoint, recordsName, countName, searchRecord = {}, callback = this.onRecordLoad) {
            let loader = this.$loading.show()
            this[recordsName || 'records'] = []
            if (!apiEndpoint && !Object.keys(searchRecord).length) {
                searchRecord = Object.assign({}, this.searchRecord)
            }
            if (page && typeof (page) !== 'object') {
                searchRecord.page = page
            }
            try {
                let data = await CreditsManagerService.getAll(apiEndpoint || this.apiEndpoint, searchRecord)
                this[recordsName || 'records'] = data.items
                this[countName || 'total'] = data.count ? data.count : data.items.length

                await callback(this[recordsName || 'records'])

                loader.hide()
            } catch (error) {
                loader.hide()
                console.error(error)
                this.$swal({
                    title: 'Error',
                    text: 'No se pudieron cargar los registros, contacta al administrador',
                    icon: 'error'
                })
            }
        },

        async loadRecordCM2 (id, prop = 'record', apiEndpoint = null, callback = this.onRecordLoad) {
            let loader = this.$loading.show()
            try {
                let endpoint = this.apiEndpoint
                if (apiEndpoint) {
                    endpoint = apiEndpoint
                }

                let data = await CreditsManagerService.getOne(endpoint, id)
                Vue.set(this, prop, data)
                Vue.set(this.record, 'editing', false)
                this.errors = []

                await callback(data)

                loader.hide()
            } catch (error) {
                console.error(error)
                loader.hide()
                this.$swal({
                    title: 'El ' + this.recordName + ' no existe',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Volver al listado',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: false
                }).then(async (result) => {
                    if (!apiEndpoint) {
                        this.$router.push({ name: this.recordName + 'List' })
                    }
                })
            }
        },

        async restoreRecordsCM2 (apiEndpoint, recordsName, countName, searchRecord) {
            this[searchRecord || 'searchRecord'] = {
                page: 1,
                pageSize: 35,
                order: 'ASC'
            }
            this.loadRecordsCM2(1, apiEndpoint || this.apiEndpoint, recordsName || this.recordsName, countName || this.countName, this.searchRecord)
        },

        async processActionCM2 (action, actionData = {}, ask = true, reloadRecord = true, modalConfig = {}, recordName = this.recordName, apiEndpoint = this.apiEndpoint, showLoading = true) {
            this.failed = false
            if (!Utils.userHasPerm(`can_${action}_${recordName}`)) {
                this.$swal({
                    title: 'No tienes permiso para realizar la acción',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Cerrar',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: false
                })
                return
            }

            let endpoint = apiEndpoint + action

            if (ask) {
                this.$swal({
                    title: modalConfig.title ? modalConfig.title : '¿Deseas confirmar la operación?',
                    html: modalConfig.html ? modalConfig.html : 'Una vez realizada no se puede cancelar',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Si',
                    confirmButtonColor: '#2BBA45',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'No',
                    showCloseButton: false
                }).then(async (result) => {
                    if (result.value === true) {
                        let loader = null
                        if (showLoading) loader = this.$loading.show()

                        try {
                            let data = await CreditsManagerService.executeAction(endpoint, actionData)
                            let msg = data.message ? data.message : 'Operación realizada'
                            if (showLoading) loader.hide()
                            this.$swal('Éxito', msg, 'success').then(async (result) => {
                                if (reloadRecord) await this.loadRecord(this.$route.params.id)
                            })
                            return data
                        } catch (error) {
                            let msg = error.data && error.data.message ? error.data.message : 'Error al accionar, contacta al administrador'
                            let errors = ''
                            if (msg.constructor === Array) {
                                for (let error of msg) errors += `${error}<br>`
                                if (showLoading) loader.hide()
                                return this.$swal({
                                    title: 'Error',
                                    html: errors,
                                    icon: 'error',
                                    showCancelButton: false,
                                    showCloseButton: false
                                }).then(async result => {
                                    return new Error(error)
                                })
                            }

                            if (showLoading) loader.hide()
                            this.$swal('Error', msg, 'error')
                            return new Error(error)
                        }
                    }
                })
            } else {
                let loader = null
                if (showLoading) loader = this.$loading.show()

                try {
                    let data = await CreditsManagerService.executeAction(endpoint, actionData)
                    if (showLoading) loader.hide()
                    return data
                } catch (error) {
                    this.failed = true
                    let msg = error.data && error.data.message ? error.data.message : 'Error al accionar, contacta al administrador'
                    let errors = ''
                    if (msg.constructor === Array) {
                        for (let error of msg) errors += `${error}<br>`
                        if (showLoading) loader.hide()
                        return this.$swal({
                            title: 'Error',
                            html: errors,
                            icon: 'error',
                            showCancelButton: false,
                            showCloseButton: false
                        }).then(async (result) => {
                            return new Error(errors)
                        })
                    }

                    if (showLoading) loader.hide()
                    this.$swal({
                        title: 'Error',
                        html: msg,
                        icon: 'error',
                        showCancelButton: false,
                        showCloseButton: false
                    }).then(async (result) => {
                        return new Error(errors)
                    })

                    return new Error(msg)
                }
            }
        },

        userHasPerm (permission) {
            if (!Utils.userHasPerm(permission)) {
                this.$swal({
                    title: 'No tienes permiso para realizar la acción',
                    html: 'Debes solicitar permiso al administrador',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Ok',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: false
                })
                return false
            }
            return true
        },

        navigateTo (id = null, name = this.recordName, target = 'Detail') {
            if (target !== 'Detail') {
                this.$router.push({ name: `${name}${target}` })
                return
            }

            if (id) {
                this.$router.push({ name: name + 'Detail', params: { id } })
            } else {
                this.$router.push({ name: name + 'Detail' })
            }
        },

        newTabTo (id = null, name = this.recordName, target = 'Detail') {
            let routeData = this.$router.resolve({ name: `${name}${target}`, params: { id } })
            window.open(routeData.href, '_blank')
        },

        goToExternalLink (uri, target = '_blank') {
            window.open(uri, '_blank')
        },

        showFilteredListByProduct () {
            const data = Object.assign((this.$store.getters.filters[this.recordName] || {}), { product: [this.record.productId] })
            this.$store.dispatch('setFilters', { recordName: this.recordName, data })
            this.$router.push({ name: this.recordName + 'List' })
        },

        async onRecordLoad () {},

        async loadRecord (id, prop = 'record', apiEndpoint = null, callback = this.onRecordLoad) {
            let loader = this.$loading.show()
            try {
                let endpoint = this.apiEndpoint
                if (apiEndpoint) {
                    endpoint = apiEndpoint
                }

                const service = this.recordService || GenericService
                let data = await service.getOne(endpoint, id)
                Vue.set(this, prop, data)
                Vue.set(this.record, 'editing', false)
                this.errors = []

                await callback(data)

                loader.hide()
            } catch (error) {
                console.error(error)
                loader.hide()
                this.$swal({
                    title: 'El ' + this.recordName + ' no existe',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Volver al listado',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: false
                }).then(async (result) => {
                    if (!apiEndpoint) {
                        this.$router.push({ name: this.recordName + 'List' })
                    }
                })
            }
        },

        editRecord () {
            if (!Utils.userHasPerm('can_edit_' + this.recordName)) {
                this.$swal({
                    title: 'Error',
                    text: 'No tienes permiso para realizar la accion',
                    icon: 'error'
                })
                return
            }
            Vue.set(this.record, 'editing', true)
        },

        cancelEditRecord () {
            Vue.set(this.record, 'editing', false)
            if (this.$route.params.id) {
                this.loadRecord(this.$route.params.id)
            } else {
                this.$router.push({ name: this.recordName + 'List' })
            }
        },

        validateData () {
            return true
        },

        // todo: implementar un clean before, (para evitar payloads grandes)
        async saveRecord (record, reload = true, apiEndpoint = null) {
            let loader = this.$loading.show()
            let endpoint = this.apiEndpoint
            if (apiEndpoint) {
                endpoint = apiEndpoint
            }
            await this.validateData()
            if (this.errors.length > 0) {
                loader.hide()
                return
            }
            if (record.id) {
                try {
                    let data = await GenericService.update(endpoint, record)
                    if (reload) {
                        await this.loadRecord(this.$route.params.id)
                    }
                    loader.hide()
                    return data
                } catch (error) {
                    console.error(error)
                    let errors = ''
                    let msg = error.data && error.data.message ? error.data.message : 'Error al guardar, contacta al administrador'
                    if (msg.constructor === Array) {
                        for (let error of msg) {
                            errors += `${error}<br>`
                        }
                        loader.hide()
                        return this.$swal({
                            title: 'Error',
                            html: errors,
                            icon: 'error',
                            showCancelButton: false,
                            showCloseButton: false
                        }).then(async (result) => {
                            return new Error(error)
                        })
                    }

                    loader.hide()
                    this.$swal('Error', msg, 'error')
                    return new Error(error)
                }
            } else {
                try {
                    let data = await GenericService.create(endpoint, record)
                    loader.hide()
                    if (reload) {
                        Vue.set(this.record, 'id', data.record.id)
                        Vue.set(this.record, 'editing', false)
                        this.$router.push({ name: this.recordName + 'Detail', params: { id: data.record.id } })
                    }
                    return data
                } catch (error) {
                    let errors = ''
                    let msg = error.data && error.data.message ? error.data.message : 'Error al crear, contacta al administrador'
                    if (msg.constructor === Array) {
                        for (let error of msg) {
                            errors += `${error}<br>`
                        }
                        loader.hide()
                        return this.$swal({
                            title: 'Error',
                            html: errors,
                            icon: 'error',
                            showCancelButton: false,
                            showCloseButton: false
                        }).then(async (result) => {
                            return new Error(error)
                        })
                    }

                    loader.hide()
                    this.$swal('Error', msg, 'error')
                    return new Error(error)
                }
            }
        },

        processFunction (name, params = null) {
            return this[name](params)
        },

        async processRecordAction (action, actionData = {}, ask = true, reloadRecord = true, modalConfig = {}, id = null, onSuccess = () => {}, showLoading = true) {
            let recordId = this.record.id
            if (id) recordId = id

            if (!recordId || !this.apiEndpoint) {
                this.$swal('Error', 'Error al procesar acción, consulta al administrador', 'error')
                return
            }

            if (!Utils.userHasPerm(`can_${action}_${this.recordName}`)) {
                this.$swal({
                    title: 'No tienes permiso para realizar la acción',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Cerrar',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: false
                })
                return
            }

            if (ask) {
                this.$swal({
                    title: modalConfig.title ? modalConfig.title : '¿Deseas confirmar la operación?',
                    html: modalConfig.html ? modalConfig.html : 'Una vez realizada no se puede cancelar',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Si',
                    confirmButtonColor: '#2BBA45',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    allowOutsideClick: false
                }).then(async (result) => {
                    if (result.value === true) {
                        let loader = null
                        if (showLoading) loader = this.$loading.show()
                        let endpoint = this.apiEndpoint
                        endpoint = endpoint.concat(recordId, '/', action, '/')

                        try {
                            let data = await GenericService.executeAction(endpoint, actionData)
                            let msg = data.message ? data.message : 'Operación realizada'
                            if (showLoading) loader.hide()
                            this.$swal('Éxito', msg, 'success').then(async (result) => {
                                if (reloadRecord) {
                                    await this.loadRecord(this.$route.params.id)
                                }
                            }).then(async () => onSuccess())
                            return data
                        } catch (error) {
                            let msg = error.data && error.data.message ? error.data.message : 'Error al accionar, contacta al administrador'
                            let errors = ''
                            if (msg.constructor === Array) {
                                for (let error of msg) {
                                    errors += `${error}<br>`
                                }
                                if (showLoading) loader.hide()
                                return this.$swal({
                                    title: 'Error',
                                    html: errors,
                                    icon: 'error',
                                    showCancelButton: false,
                                    showCloseButton: false
                                }).then(async (result) => {
                                    return new Error(error)
                                })
                            }

                            if (showLoading) loader.hide()
                            this.$swal('Error', msg, 'error')
                            return new Error(error)
                        }
                    }
                })
            } else {
                let loader = null
                if (showLoading) loader = this.$loading.show()
                let endpoint = this.apiEndpoint
                endpoint = endpoint.concat(recordId, '/', action, '/')

                try {
                    let data = await GenericService.executeAction(endpoint, actionData)
                    if (showLoading) loader.hide()
                    if (reloadRecord) {
                        await this.loadRecord(this.$route.params.id)
                    }
                    return data
                } catch (error) {
                    let msg = error.data && error.data.message ? error.data.message : 'Error al accionar, contacta al administrador'
                    let errors = ''
                    if (msg.constructor === Array) {
                        for (let error of msg) {
                            errors += `${error}<br>`
                        }
                        if (showLoading) loader.hide()
                        return this.$swal({
                            title: 'Error',
                            html: errors,
                            icon: 'error',
                            showCancelButton: false,
                            showCloseButton: false
                        }).then(async (result) => {
                            return new Error(errors)
                        })
                    }

                    if (showLoading) loader.hide()
                    this.$swal({
                        title: 'Error',
                        html: msg,
                        icon: 'error',
                        showCancelButton: false,
                        showCloseButton: false
                    }).then(async (result) => {
                        return new Error(errors)
                    })

                    return new Error(msg)
                }
            }
        },

        async processRecordDownload (action, actionData = {}, ask = false) {
            if (!this.apiEndpoint) {
                this.$swal('Error', 'Error al procesar acción, consulta al administrador', 'error')
                return
            }

            let loader = this.$loading.show()
            let endpoint = this.apiEndpoint
            endpoint = this.record && this.record.id ? endpoint.concat(this.record.id, '/', action, '/') : endpoint.concat(action, '/')

            try {
                let data = await GenericService.downloadFile(endpoint, actionData)
                let link = document.createElement('a')
                let newBlob = Utils.converBase64toBlob(data.base64, 'application/pdf')
                link.href = URL.createObjectURL(newBlob)
                link.target = '_blank'
                loader.hide()
                link.click()
                return data
            } catch (error) {
                let msg = error.data && error.data.message ? error.data.message : 'Error al accionar, contacta al administrador'
                loader.hide()
                throw new Error(msg)
            }
        },

        async processAction (action, actionData = {}, ask = true, reloadRecord = true, modalConfig = {}, recordName = this.recordName, apiEndpoint = this.apiEndpoint, showLoading = true) {
            this.failed = false
            if (!Utils.userHasPerm(`can_${action}_${recordName}`)) {
                this.$swal({
                    title: 'No tienes permiso para realizar la acción',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Cerrar',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: false
                })
                return
            }

            let endpoint = apiEndpoint + action

            if (ask) {
                this.$swal({
                    title: modalConfig.title ? modalConfig.title : '¿Deseas confirmar la operación?',
                    html: modalConfig.html ? modalConfig.html : 'Una vez realizada no se puede cancelar',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Si',
                    confirmButtonColor: '#2BBA45',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'No',
                    showCloseButton: false
                }).then(async (result) => {
                    if (result.value === true) {
                        let loader = null
                        if (showLoading) loader = this.$loading.show()

                        try {
                            let data = await GenericService.executeAction(endpoint, actionData)
                            let msg = data.message ? data.message : 'Operación realizada'
                            if (showLoading) loader.hide()
                            this.$swal('Éxito', msg, 'success').then(async (result) => {
                                if (reloadRecord) await this.loadRecord(this.$route.params.id)
                            })
                            return data
                        } catch (error) {
                            let msg = error.data && error.data.message ? error.data.message : 'Error al accionar, contacta al administrador'
                            let errors = ''
                            if (msg.constructor === Array) {
                                for (let error of msg) errors += `${error}<br>`
                                if (showLoading) loader.hide()
                                return this.$swal({
                                    title: 'Error',
                                    html: errors,
                                    icon: 'error',
                                    showCancelButton: false,
                                    showCloseButton: false
                                }).then(async result => {
                                    return new Error(error)
                                })
                            }

                            if (showLoading) loader.hide()
                            this.$swal('Error', msg, 'error')
                            return new Error(error)
                        }
                    }
                })
            } else {
                let loader = null
                if (showLoading) loader = this.$loading.show()

                try {
                    let data = await GenericService.executeAction(endpoint, actionData)
                    if (showLoading) loader.hide()
                    return data
                } catch (error) {
                    this.failed = true
                    let msg = error.data && error.data.message ? error.data.message : 'Error al accionar, contacta al administrador'
                    let errors = ''
                    if (msg.constructor === Array) {
                        for (let error of msg) errors += `${error}<br>`
                        if (showLoading) loader.hide()
                        return this.$swal({
                            title: 'Error',
                            html: errors,
                            icon: 'error',
                            showCancelButton: false,
                            showCloseButton: false
                        }).then(async (result) => {
                            return new Error(errors)
                        })
                    }

                    if (showLoading) loader.hide()
                    this.$swal({
                        title: 'Error',
                        html: msg,
                        icon: 'error',
                        showCancelButton: false,
                        showCloseButton: false
                    }).then(async (result) => {
                        return new Error(errors)
                    })

                    return new Error(msg)
                }
            }
        },

        async processRecordUpload (action, actionData = {}, ask = false) {
            if (!this.apiEndpoint) {
                this.$swal('Error', 'Error al procesar acción, consulta al administrador', 'error')
                return
            }

            let loader = this.$loading.show()
            let endpoint = this.apiEndpoint
            endpoint = this.record && this.record.id ? endpoint.concat(this.record.id, '/', action, '/') : endpoint.concat(action, '/')

            try {
                let data = await GenericService.uploadFile(endpoint, actionData)
                loader.hide()
                return data
            } catch (error) {
                let msg = error.data && error.data.message ? error.data.message : 'Error al accionar, contacta al administrador'
                loader.hide()
                throw new Error(msg)
            }
        },

        downloadAsFile (content, config = { encoding: 'utf-8', filetype: 'text/plain', fileName: 'file', fileExtension: '.txt' }) {
            const { encoding, filetype, fileExtension, fileName } = config
            const data = `${filetype};charset=${encoding}, ${encodeURIComponent(JSON.stringify(content))}`

            let link = document.createElement('a')
            link.href = 'data: ' + data
            link.download = `${fileName}${fileExtension}`
            link.click()
        },

        forceUpper (e, obj, prop) {
            let newValue = obj[prop].toUpperCase()
            this.$set(obj, prop, newValue)
        },

        forceLower (e, obj, prop) {
            let newValue = obj[prop].toLowerCase()
            this.$set(obj, prop, newValue)
        },

        displayCreditStatusName (status) {
            if (status === this.CreditStatus.DISPERSION_PENDIENTE) {
                return { name: 'Dispersión pendiente', color: 'black' }
            }
            if (status === this.CreditStatus.CERRADO) {
                return { name: 'Cerrado', color: 'black' }
            }
            if (status === this.CreditStatus.ETAPA_1) {
                return { name: 'Etapa 1', color: 'black' }
            }
            if (status === this.CreditStatus.ETAPA_2) {
                return { name: 'Etapa 2', color: 'black' }
            }
            if (status === this.CreditStatus.ETAPA_3) {
                return { name: 'Etapa 3', color: 'red' }
            }
            return { name: 'Desconocido', color: 'black' }
        },

        displayIsDelayed (daysOverDue) {
            if (daysOverDue > 0) {
                return { name: 'VENCIDO', color: 'red' }
            }
            return { name: 'VIGENTE', color: 'green' }
        },

        getBusinessUnitColor (unit) {
            if (unit.toLowerCase() === 'pyme') { return 'blue' }
            if (unit.toLowerCase() === 'floreser') { return 'pink' }
            if (unit.toLowerCase() === 'agro') { return 'teal' }
        }
    },

    computed: {
        clientDetailUrl () {
            if (this.record.clientId) {
                return `${process.env.VUE_APP_BASE_URL}/clients/clientDetails/${this.record.clientId}`
            }
            return ''
        },
        creditDetailUrl () {
            const baseUrl = `${process.env.VUE_APP_BASE_URL}/credits/details`
            if (this.record.creditId) {
                return `${baseUrl}/${this.record.creditId}`
            }
            if (this.record.credit && this.record.credit.id) {
                return `${baseUrl}/${this.record.credit.id}`
            }
            return ''
        }
    },

    filters: {
        date (v) {
            if (!v) return null
            return moment(v).locale('es').format('DD MMM YYYY')
        },

        dateShort (v) {
            if (!v) return null
            return moment(v).locale('es').format('DD/MM/YYYY')
        },

        dateTime (v) {
            if (!v) return null
            return moment(v).local().format('DD MMM YYYY h:mm a')
        },

        percentage (val, decimals = 2, base = 100) {
            if (!val) val = 0
            let value = 0
            if (base === 100) {
                value = (val * 100).toFixed(decimals)
            } else {
                value = (val).toFixed(decimals)
            }
            return `${value}%`
        },

        upper (v) {
            if (v) return v.toUpperCase()
        },

        lower (v) {
            if (v) return v.toLowerCase()
        }
    }
}
